import React from 'react';
import { Card } from '@mui/material';
// if you change this, change the 'width' in profileCard.less as well
export var PROFILE_CARD_WIDTH = 450;
var ProfileCard = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement(Card, { className: 'profileCard' },
        React.createElement("div", { className: 'profileCard__title' }, title),
        React.createElement("div", { className: 'profileCard__content' }, children)));
};
export default ProfileCard;
//# sourceMappingURL=ProfileCard.js.map